<template>
  <div class="fill-height">


    <div class="d-flex flex-wrap justify-space-around align-baseline">

      <v-card style="max-width: 600px" class="ma-2 flex-grow-1 flex-equal">

<!--        <v-card-title class="dlg-title-bar">-->
<!--          <div class="flex-grow-1 flex-equal">Management Options</div>-->
<!--          <div class="flex-grow-1 flex-equal">AI Usage Report</div>-->
<!--        </v-card-title>-->

        <v-card-text class="pt-3">

<!--          <v-card-title class="dlg-title-bar">-->
<!--            <div class="flex-grow-1 flex-equal">Management Options</div>-->
<!--            <div class="flex-grow-1 flex-equal">AI Usage Report</div>-->
<!--          </v-card-title>-->

          <div class="d-flex">
            <div class="flex-grow-1 flex-equal">
              <v-card-title class="dlg-title-bar pa-0 ma-0">
                <div class="flex-grow-1 flex-equal">Management Options</div>
              </v-card-title>

              <v-btn
                class="mt-5"
                color="primary"
                @click="showCreateNewSiteDialog = true"
              >Create New Site</v-btn>

              <v-btn
                class="mt-5"
                color="primary"
                :loading="loadingDeviceReport"
                :disabled="loadingDeviceReport"
                @click="downloadDeviceReport"
              >Download Device Report</v-btn>
            </div>

            <div class="flex-grow-1 flex-equal">
              <v-card-title class="dlg-title-bar pa-0 ma-0">
                <div class="flex-grow-1 flex-equal">AI Usage Report</div>
              </v-card-title>

              <v-btn
                class="mt-5"
                color="primary"
                :loading="loadingAiUsageReport"
                :disabled="loadingAiUsageReport"
                @click="downloadAiUsageReport"
              >Download AI Usage Report</v-btn>
            </div>
          </div>

        </v-card-text>
      </v-card>
    </div>



    <app-dlg
      v-if="showCreateNewSiteDialog"
      :show-dlg="!!showCreateNewSiteDialog"
      @update-show-dlg="showCreateNewSiteDialog = null"
      title="Create New Site"
      :default-padding="false"
      :dlg-width="750"
    >

      <app-signup
        @siteVerified="newSiteVerified"
      ></app-signup>

      <template v-slot:actions>
        <v-btn
          small
          class="ml-2"
          size="small"
          color="error"
          variant="contained"
          @click="showCreateNewSiteDialog = false"
        >Cancel</v-btn>
      </template>
      
    </app-dlg> <!-- Create New Site -->

  </div>
</template>

<script>
import AppPartner from "@/components/Partner/AppPartner";
import AppCentreLoader from "@/components/Shared/AppCentreLoader";
import {copyText, mergeRecursive, nameSort, validationRules} from "@/core/codeFunctions";
import {mapGetters} from "vuex";
import xls from 'json-as-xlsx';
import {format} from "date-fns";
import AppDlg from "@/components/Shared/AppDlg.vue";
import AppSignup from "@/components/Signup/AppSignup";


export default {
  components: {AppDlg, AppCentreLoader, AppPartner, AppSignup},
  props: {
    val: Boolean,
  },
  data() {
    return {
      loadingDeviceReport: false,

      loadingAiUsageReport: false,

      showCreateNewSiteDialog: false,
    }
  },
  watch: {},
  methods: {
    async downloadDeviceReport() {
      try {
        this.loadingDeviceReport = true;
        const devices = await this.$newReq('GET', `partner/global/DeviceReport`)

        const columns = [
          {label: "Site Name", value: "siteName"},
          {label: "Employee Name", value: "employeeName"},
          {label: "Device Name", value: "deviceName"},
          {label: "Host Name", value: "hostName"},
          {label: "Username", value: "username"},
          {label: "App Version", value: "appVersion"},
          {label: "Launcher Version", value: "launcherVersion"},
          {label: "Update Version", value: "updateVersion"},
          {label: "App Status", value: "appStatus"},
          {label: "Launcher Status", value: "launcherStatus"},
          {label: "Update Status", value: "updateStatus"},
          {label: "Status", value: "status"},
        ]
        // const content = srcData.map(obj => {
        //     const row = {}
        //
        //     columns.forEach(col => {
        //         switch (col.value) {
        //             case 'label': {row[col.value] = labelsRef[obj[col.value]].text; break;}
        //             case 'tt': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
        //             case 'ttn': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
        //             case 'tto': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
        //             case 'workTime': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
        //             case 'activeTime': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
        //             case 'ptt': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
        //             case 'ptn': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
        //             case 'pto': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
        //             case 'utt': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
        //             case 'utn': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
        //             case 'uto': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
        //             case 'ntt': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
        //             case 'ntn': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
        //             case 'nto': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
        //             case 'ttt': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
        //             case 'idleTime': {row[col.value] = hourDisplayDecimal(obj[col.value], true); break;}
        //             case 'productivityTarget': {row[col.value] = percentDisplayWithoutUnit(obj[col.value]); break;}
        //             case 'productivityActive': {row[col.value] = percentDisplayWithoutUnit(obj[col.value]); break;}
        //             case 'productivityWorkTime': {row[col.value] = percentDisplayWithoutUnit(obj[col.value]); break;}
        //             default: row[col.value] = obj[col.value]
        //         }
        //     })
        //
        //     return row
        // })
        let data = [{
          sheet: "Device Version Report",
          columns: columns,
          content: devices
        }]
        let settings = {
          fileName: `Device Report ${format(new Date(), 'yyyy-MM-dd')}`,
        }
        xls(data, settings)


        // console.log(devices)
      } catch (e) {
        this.$snack.netWorkError()
        console.log(e)
      } finally {
        this.loadingDeviceReport = false
      }

    },

    async downloadAiUsageReport() {
      try {
        this.loadingAiUsageReport = true;
        const aIUsageReportData = await this.$newReq('GET', `partner/global/aiUsageReport`);

        const columns = [
          {label: "Site", value: "site"},
          {label: "Period", value: "period"},
          {label: "AI Requests", value: "aiRequests"},
          {label: "Candidates Token Count", value: "candidatesTokenCount"},
          {label: "Prompt Token Count", value: "promptTokenCount"},
          {label: "Total Token Count", value: "totalTokenCount"},
        ]

        let data = [{
          sheet: "AI Usage Report",
          columns: columns,
          content: aIUsageReportData
        }]

        let settings = {
          fileName: `AI Usage Report ${format(new Date(), 'yyyy-MM-dd')}`,
        }

        xls(data, settings);

      } catch (e) {
        this.$snack.netWorkError();
        console.log(e)
      } finally {
        this.loadingAiUsageReport = false;
      }

    },

    newSiteVerified() {
      this.showCreateNewSiteDialog = false;
      this.$snack.info('New Site Created');
    }
  },
  computed: {
    ...mapGetters(["user"]),
  }
}
</script>

<style scoped>

</style>